import { render, staticRenderFns } from "./CraftItemSwitch.vue?vue&type=template&id=505e701a&scoped=true&"
import script from "./CraftItemSwitch.vue?vue&type=script&lang=ts&"
export * from "./CraftItemSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e701a",
  null
  
)

export default component.exports